import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('enabled')
];

const config: IFormConfig = {
	title: 'Aggiungi integrazione',
	fields: formFields 
};

export default config;
